export const AMPLITUDE_PRODUCT_CLICKED = 'product_clicked' as const;
export const AMPLITUDE_MODULE_CLICKED = 'module_click' as const;
export const AMPLITUDE_PRODUCT_FAVORITES_ADD = 'favorite_add' as const;

export const AMPLITUDE_PRODUCT_CLICKED_EVENT_ID = 70 as const;
export const AMPLITUDE_PRODUCT_FAVORITES_ADD_EVENT_ID = 70 as const;

export const GTM_EVENT_KEY = 'gtm.uniqueEventId' as const;
